<!--
     <TextInput
       :props="my_attrs_dictionary"
     />

     Public propertys:
       value → Gives the field's serializable value

     Public methods:
       validate → Makes validation and returns if the value is valid

     Accepted props:
     - value
     - size
     - label
     - placeholder
     - required
     - readonly
     - class
     - is_password
     - is_email
     - diabled
-->

<template>
  <v-text-field
    v-model="props.value"
    :size="props.size"
    :label="props.label"
    :placeholder="props.placeholder"
    :rules="[check_trim, is_required, is_email].concat(props.rules || [])"
    :readonly="!!props.readonly"
    :type="show ? 'text' : 'password'"
    @error="error_state"
    :class="[
      props.class || props.readonly ? 'qmkey-form-input-readonly': 'qmkey-form-input',
      { required: props.required }
    ]"
    :append-icon="this.props.is_password ? (show ? 'mdi-eye' : 'mdi-eye-off') : null"
    @click:append="show = !show"
    outlined
    dense
    background-color="#f2f2f2"
    :disabled="!!props.disabled || !!props.readonly"
    :hideDetails="!!props.hide_details"
    @change="update"
  >
  </v-text-field>
</template>
<script>

export default {
  name: 'TextInput',

  props: ['props', 'required_rule'],

  data: () => ({
    valid: true,
    show: true,
  }),
  mounted(){
    this.show=!this.props.is_password
  },

  computed: {
    value() {
      return this.props.value && this.props.value.trim() || null
    },
  },

  methods: {
    validate() {
      return this.valid
    },

    check_trim(value) {
      // TODO: Multilang: Change hardcoded string
      if (value) return value.indexOf(' ') != 0 || this.$vuetify.lang.translator('inputs.start_space') 
      return true
      
    },
    is_required(value) {
      // TODO: Multilang: Change hardcoded string
      return !!value || !this.props.required || this.$vuetify.lang.translator('required_field')
    },
    is_email(value) {
      if (this.props.is_email) return !value || (/.+@.+\.+\w+/.test(value)) || this.$vuetify.lang.translator('inputs.email_invalid') 
      return true
    },
    error_state(ok) {
      this.valid = ok
    },
    update(value) {
      this.$emit('update',(value != "" ? value : null));
    },
  },
}
</script>
<style lang="scss">
@import '@/sass/modalform.scss';
</style>
